import { HttpService, resolveService } from "@reco-m/core";
export class FlowDesignHttpService extends HttpService {
    constructor() {
        super("flow/design");
    }
}
export const flowDesignService = resolveService(FlowDesignHttpService);
